module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00723.e073c76b.jpg";